<template>
    <div class="productDataBox">
        <!-- <div class="chainTitle">产品数据</div> -->
        <div v-if="productData.length>0" :class="!isClickFlag?'box':'box showRight'">
            <div id="mainData" class="main" style="width: 100%;height:100%;" ></div>
            <div class="boxRight" v-if="productSeries.length>0&&isClickFlag">
                <div class="listTop">
                    <div class="listTitle">{{ isSelectTitle }}</div>
                    <ul>
                        <li v-for="(item,index) in productSeries" :key="index" @click="getLineInfo(item)">{{ item.seriesName }}</li>
                    </ul>
                </div>
                <div class="lineBotton">
                    <div id="mainDataLine" class="main" style="width: 100%;height:100%;" ></div>
                </div>
            </div>
        </div>
        <DataEmpty v-if="productData.length==0&&isEnd"></DataEmpty>

    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import DataEmpty from '../dataEmpty.vue'
  import baseUrl from '@/utils/setting'
  export default {
    name: 'productData',
    data() {
        return {
            productData: [],
            productSeries:[],
            showLineData:[],
            isClickFlag:false,
            isSelectTitle:'',
            isEnd:false
        }
    },
    computed: {...mapState(['productShowInfo','productRouterInfo','colorArr'])},
    components:{ DataEmpty },
    created(){
        this.getProductData(this.productRouterInfo);
    },
    methods: {
        //获取产品数据
        getProductData( params ){
            this.isEnd = false
            this.$store.dispatch('getProductData',{productCode:params.productCode}).then( res => {
                this.isEnd = true
                if( res.status == 200 ){
                    this.productData = res.data.data
                    if( this.productData.length>0){
                        this.showGraph(60);
                    }
                }
            })
        },
        //获取产品指标
        getProductSeries(params){
            this.$store.dispatch('getProductSeries',{productCode:this.productRouterInfo.productCode,typeName:params.typeName}).then( res => {
                if(res.data.retCode == '000'){
                    this.productSeries = res.data.data
                }
            });
        },
        //获取折线图数据
        getLineInfo(params){
            let that = this;
            this.$store.dispatch('getProductSeriesData',{seriesCode:params.seriesCode}).then( res => {
                if( res.data.retCode == '000'){
                    if( res.data.data.list.length>0){
                        that.showLine(res.data.data);
                    }
                }
            })
        },
        //展示关系图
        showGraph(){
            let that = this,elList=[],myChart = [],data = [],links = [],num=0;
            let color = ['#665b6f', '#865554', '#b26d42', '#5a799f', '#937da8', '#af8641', '#ac645b']
            data.push({
                    value : that.productRouterInfo.name,
                    name : that.productRouterInfo.name,
                    symbolSize : 40,
                    draggable: true,
                    code : that.productRouterInfo.productCode,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[0]
                        }
                    }
            })
            that.productData.forEach(function( item,index ){
                num = index+1
                data.push({
                    value : item.typeName,
                    name : item.typeName,
                    symbolSize : 30,
                    typeFlag : 'product',
                    typeName : item.typeName,
                    symbolKeepAspect:true,
                    itemStyle: {
                        normal: {
                            // color:num>that.colorArr.length?that.colorArr[num-that.colorArr.length]: that.colorArr[num]
                            color: color[index]
                        }
                    }
                })
                links.push({
                        source:  that.productRouterInfo.name,
                        target:  item.typeName
                })
            })
            var option = {
                title: {text: ''},
                tooltip: {
                    show: true,
                    trigger: 'item'
                },
                animation: false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    symbolSize: 50,
                    draggable: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        },
                    },
                    itemStyle: {
                        normal: {
                        label: {
                            textStyle: {
                                // 用 itemStyle.normal.label.textStyle.fontSize 來更改餅圖上項目字體大小
                                fontSize:14
                            }
                        }
                        }
                    },
                    force: {                // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                                    // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                        repulsion: 300,            // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength:105      // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                                                    // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                                                        // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    links:links,
                    tooltip: {
                        formatter: '{b}',
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainData'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    if(param.data.source&&param.data.target){
                        return;
                    }
                    if(!param.data.typeName){
                        that.isClickFlag = false;
                        return;
                    }
                    that.isClickFlag = true;
                    that.isSelectTitle = param.data.typeName
                    that.getProductSeries(param.data);
                });
            })
        },
        //展示折线图
        showLine(params){
            let that = this,elList=[],myChart = [], xData = [],seriesData = [],maxMinVal = {};
            maxMinVal.min = params.minValue;
            maxMinVal.max = params.maxValue;
            let list = params.list
            list.forEach(function( it ){
                xData.push(it.dataTime.split(' ')[0]),
                seriesData.push(it.dataValue)
            })
            var option = {
                    title: {
                        left: 'center',
                        text: list[0].seriesName,
                        // subtext: list[0].seriesCode,
                        textStyle: {
                          fontSize: 13
                        },
                        subtext: '下载数据',
                        sublink: baseUrl+'/user/downLoadSeriesData?seriesCode='+list[0].seriesCode+'&Authorization='+sessionStorage.getItem('authToken'),
                        subtarget:"blank",
                        subtextStyle:{//副标题内容的样式
                          color: '#d16c5d',
                          fontStyle:'normal',//主标题文字字体风格，默认normal，有italic(斜体),oblique(斜体)
                          fontWeight:"bold",//可选normal(正常)，bold(加粗)，bolder(加粗)，lighter(变细)，100|200|300|400|500...
                          fontFamily:"san-serif",//主题文字字体，默认微软雅黑
                          fontSize:10//主题文字字体大小，默认为12px
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params = params.list) {
                            params = params[0];
                            return params.value+'<br />'+params.name;
                        },
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid : {
                        containLabel:true
                    },
                    xAxis: {
                        type: 'category',
                        data: xData,
                        splitNumber:5,
                        axisLabel:{
                            rotate:30,
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: parseInt(maxMinVal.min<0?maxMinVal.min*1.2:maxMinVal.min*0.8),
                        max: parseInt(maxMinVal.max<0?maxMinVal.max*0.8:maxMinVal.max*1.2),
                        splitNumber:5
                    },
                    series: [{
                        name:list[0].seriesName,
                        type:'line',
                        data:seriesData
                    }]
            };
            this.$nextTick(function(){

                myChart = that.$echarts.init( document.getElementById('mainDataLine'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    that.isClickFlag = true;
                    that.getProductSeries(param.data);
                });
            })
        }
    },
    mounted() {},
  }
</script>

<style lang="scss" src="../../../sass/productInfo/productData.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/productCom/productData.vue